import React from 'react'
import PanelHeader from '../panel-header-candidate'
import CandidateTable from '../candidate-table'
import styles from '../../candidate.module.css'

const ListCandidateView = () => (
    <>
        <PanelHeader />
        <div className={styles.content}>
            <CandidateTable />
        </div>
    </>
)

export default ListCandidateView
